module.exports = __webpack_public_path__ + "img/企业文化图片.b0dd7705.png";